var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectadd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 440 440",
    width: "440pt",
    height: "440pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_R9xHoj8rMWqKzwGRB8kFD4ZZMOPAUSNg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_R9xHoj8rMWqKzwGRB8kFD4ZZMOPAUSNg)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_2NytdPAlr2D5IniNkrg1zjLxZm8BpRDF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 440,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_2NytdPAlr2D5IniNkrg1zjLxZm8BpRDF)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 220 340 C 220 284.808 264.808 240 320 240 C 375.192 240 420 284.808 420 340 C 420 395.192 375.192 440 320 440 C 264.808 440 220 395.192 220 340 Z  M 362.236 330.571 L 329.397 330.571 L 329.397 297.76 C 329.397 292.566 325.206 288.355 320.013 288.355 C 314.819 288.355 310.631 292.566 310.631 297.762 L 310.631 330.594 L 277.775 330.594 C 272.582 330.594 268.359 334.805 268.362 340.001 C 268.359 342.597 269.408 344.976 271.108 346.676 C 272.809 348.38 275.157 349.456 277.75 349.456 L 310.631 349.456 L 310.631 382.243 C 310.631 384.841 311.661 387.193 313.363 388.89 C 315.064 390.592 317.405 391.645 320.003 391.645 C 325.195 391.645 329.397 387.434 329.397 382.243 L 329.397 349.454 L 362.236 349.454 C 367.43 349.454 371.641 345.206 371.638 340.013 C 371.636 334.821 367.425 330.571 362.236 330.571 Z ",
    fillRule: "evenodd",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 235.285 15 L 235.285 85 L 305.285 85 L 235.285 15 L 235.285 15 Z ",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 70.285 347.5 L 70.285 317.5 L 192.917 317.5 C 195.497 303.219 200.434 289.75 207.299 277.5 L 70.285 277.5 L 70.285 247.5 L 230.438 247.5 C 253.734 225.004 285.419 211.141 320.285 211.141 L 320.285 115 L 205.285 115 L 205.285 0 L 20.285 0 L 20.285 415 L 214.464 415 C 200.851 395.701 192.369 372.535 191.042 347.5 L 70.285 347.5 L 70.285 347.5 L 70.285 347.5 Z  M 70.285 177.5 L 270.285 177.5 L 270.285 207.5 L 70.285 207.5 L 70.285 177.5 L 70.285 177.5 L 70.285 177.5 Z ",
    fill: "rgb(0,0,0)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectadd);
export default __webpack_public_path__ + "static/media/projectadd.64b9b4246ae1d8fcbbab3f1c4eb1fd9a.svg";
export { ForwardRef as ReactComponent };